import { z } from "zod";

export const programBasicSchema = z
  .object({
    title: z
      .string()
      .trim()
      .min(1, "Title is required")
      .max(255, "Title must be between 1 and 255 characters"),
    healthCondition: z
      .string()
      .min(1, "Please select a health condition"),
    date: z
      .any()
      .refine(
        (val) => Boolean(val) && !isNaN(new Date(val).getTime()),
        "Please select a valid date"
      ),
    cost: z
      .string()
      .trim()
      .min(1, "Cost is required")
      .refine(
        (val) => !isNaN(Number(val)) && Number(val) >= 0,
        "Cost must be a valid positive number"
      ),
    participants: z
      .string()
      .trim()
      .min(1, "Max participants is required")
      .refine(
        (val) => !isNaN(Number(val)) && Number.isInteger(Number(val)) && Number(val) > 0,
        "Max participants must be at least 1"
      ),
    hasCounselling: z.boolean(),
    totalCounsellings: z
      .string()
      .trim()
      .optional()
      .refine(
        (val) => !val || (!isNaN(Number(val)) && Number.isInteger(Number(val)) && Number(val) >= 0),
        "Total counsellings must be a positive integer"
      ),
    zoomLink: z
      .string()
      .trim()
      .min(1, "Zoom link is required")
      .refine(
        (val) => /^https?:\/\/.+/i.test(val),
        "Please enter a valid URL (e.g. https://zoom.us/...)"
      ),
    counsellingLink: z
      .string()
      .trim()
      .optional()
      .refine(
        (val) => !val || /^https?:\/\/.+/i.test(val),
        "Please enter a valid URL (e.g. https://...)"
      ),
    description: z
      .string()
      .trim()
      .min(1, "Description is required"),
  });

export type ProgramBasicFormData = z.infer<typeof programBasicSchema>;
